// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2X5C4","title":"ClientReferral_title__33vQs","itemText":"ClientReferral_itemText__3nwkX"};